import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-profile-change-profile-pictures',
  templateUrl: './profile-change-profile-pictures.component.html',
  styleUrls: ['./profile-change-profile-pictures.component.scss']
})
export class ProfileChangeProfilePicturesComponent implements OnInit {
    pagecode: string = "profile-change-picture";
    module: string = "profile";
    accessdenied: boolean = false;

    constructor(private _formBuilder: FormBuilder, private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {

    }


    imageChangedEventCover: any = '';
    croppedImageCover: any = '';

    fileChangeEventCover(event: any): void {
        this.imageChangedEventCover = event;
    }
    imageCroppedCover(event: any) {
        this.croppedImageCover = event.base64;
    }
    imageLoadedCover() {
        // show cropper
    }
    loadImageFailedCover() {
        //this.ShowMessage('error', 'Error in loading profile picture. Choose another one', '');
    }



    imageChangedEventPicture: any = '';
    croppedImagePicture: any = '';

    fileChangeEventPicture(event: any): void {
        this.imageChangedEventPicture = event;
    }
    imageCroppedPicture(event: any) {
        this.croppedImagePicture = event.base64;
    }
    imageLoadedPicture() {
        // show cropper
    }
    loadImageFailedPicture() {
        //this.ShowMessage('error', 'Error in loading profile picture. Choose another one', '');
    }


    ngOnInit(): void {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);


                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
    }
    btnSaveTextPicture: any = "Save";
    btnSaveDisabledPicture: boolean = false;

    saveProfilePicture() {
        if (this.croppedImagePicture != '') {
            this.btnSaveTextPicture = "Saving";
            this.btnSaveDisabledPicture = true;
            this.profileService.changeProfilePicture({ body: this.croppedImagePicture }, this.authentication._authentication.id).subscribe(
                (res: any) => {
                    this.btnSaveTextPicture = "Save";
                    this.btnSaveDisabledPicture = false;
                    if (res) {
                        this.authentication.userData.contactLogo = this.croppedImagePicture;
                        this.common.ShowMessage('info', 'You have successfully updated your profile picture', '');
                    }
                },
                (err: any) => {
                    this.btnSaveTextPicture = "Save";
                    this.btnSaveDisabledPicture = false;
                    this.common.ShowMessage('error', err.error_description, '');
                });
        }
        else {
            this.common.ShowMessage('info', 'Please choose your profile picture', '');
        }
    }

    btnSaveTextCover: any = "Save";
    btnSaveDisabledCover: boolean = false;
    saveCoverPicture() {
        if (this.croppedImageCover != '') {
            this.btnSaveTextCover = "Saving";
            this.btnSaveDisabledCover = true;
            this.profileService.changeProfilCoverImage({ body: this.croppedImageCover }, this.authentication._authentication.id).subscribe(
                (res: any) => {
                    this.btnSaveTextCover = "Save";
                    this.btnSaveDisabledCover = false;
                    if (res) {
                        this.authentication.userData.coverPhoto = this.croppedImageCover;
                        this.common.ShowMessage('info', 'You have successfully updated your cover picture', '');
                    }
                },
                (err: any) => {
                    this.btnSaveTextCover = "Save";
                    this.btnSaveDisabledCover = false;
                    this.common.ShowMessage('error', err.error_description, '');
                });
        }
        else {
            this.common.ShowMessage('info', 'Please choose your profile picture', '');
        }
    }
}
